/* t3p-depot (15 Oct 2026): postcode -> nearest Mainfreight depot finder + map reveal.
   Data: assets/t3p-depots.txt (built by scripts/depot_visuals.py). The depot and the distance wording are the ones
   checkout prints (the depot-label Function), so the finder and the checkout label never disagree. */
(function () {
  var cache = {};
  function num(s) { return s === undefined || s === '' ? null : +s; }
  // t3p-depots.txt: "D|i|name|address|suburb|state|postcode|price" for each depot, then "postcode|i|km|shown" for each postcode.
  // price is the depot collection price for that depot's tier (up to 3 doors).
  // km is the exact straight-line distance; shown is the figure checkout prints (blank: no distance, 0: under 10 km).
  function parse(t) {
    var D = [], P = {};
    t.split(/\r?\n/).forEach(function (l) {
      if (!l || l.charAt(0) === '#') return;
      var p = l.split('|');
      if (p[0] === 'D') { D[+p[1]] = { name: p[2], addr: p[3], sub: p[4], state: p[5], pc: p[6], price: num(p[7]) }; }
      else { P[p[0]] = { i: +p[1], km: num(p[2]), shown: num(p[3]) }; }
    });
    return { D: D, P: P };
  }
  function load(src) {
    if (!cache[src]) {
      cache[src] = fetch(src).then(function (r) { return r.text(); }).then(parse);
    }
    return cache[src];
  }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  // The wording checkout uses for the distance, from the figure the generator already rounded.
  function away(hit) {
    if (hit.shown === null) return '';
    return hit.shown === 0 ? 'under 10 km away' : 'about ' + String(hit.shown).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' km away';
  }
  function render(out, data, pc) {
    if (!/^\d{4}$/.test(pc)) { out.innerHTML = 'Enter a 4-digit postcode.'; return 'invalid'; }
    var hit = data.P[pc], d = hit && data.D[hit.i];
    if (!d) { out.innerHTML = 'We couldn\'t find that postcode. Try a nearby one, or call 1300 000 171.'; return 'unknown'; }
    var gap = away(hit), km = hit.km === null ? NaN : hit.km;
    var html = '<b>' + esc(d.name) + '</b>' + esc(d.addr) + ', ' + esc(d.sub) + ' ' + esc(d.state) + ' ' + esc(d.pc) +
      (gap ? ' <span class="t3p-dfind__km">&middot; ' + gap + '</span>' : '');
    var sydney = (d.pc === '2170' || d.pc === '2766') && km <= 45;
    if (sydney) {
      html += '<span class="t3p-dfind__note">In Sydney, home delivery is $97 for most suburbs.</span>';
    } else {
      html += '<span class="t3p-dfind__note">' + (d.price ? '$' + d.price + ' to collect here' : 'From $275 to collect') +
        ', up to 3 doors. At checkout, choose the option that starts "Collect from". It shows whenever it costs less than delivery to your door.</span>';
      if (km > 100) html += '<span class="t3p-dfind__note">That\'s a fair drive. We\'ll check with you after you order in case there\'s a closer option.</span>';
    }
    if (gap) html += '<span class="t3p-dfind__note">Distances are in a straight line from the middle of your postcode, so allow extra for the drive.</span>';
    out.innerHTML = html;
    return sydney ? 'sydney' : (km > 100 ? 'far' : 'found');
  }
  function initFinder(form) {
    if (form.__t3p) return; form.__t3p = 1;
    var input = form.querySelector('input'), out = form.querySelector('[data-t3p-depot-out]'), src = form.getAttribute('data-src');
    input.addEventListener('focus', function () { load(src); }, { once: true });
    input.addEventListener('input', function () { input.value = input.value.replace(/\D/g, '').slice(0, 4); });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var pc = input.value.trim();
      out.innerHTML = 'Finding your depot&hellip;';
      load(src).then(function (data) {
        var res = render(out, data, pc);
        if (typeof gtag === 'function') { try { gtag('event', 'cdo_depot_finder', { result: res, state_prefix: pc.charAt(0) }); } catch (er) {} }
      }).catch(function () { out.innerHTML = 'Couldn\'t load the depot list. Call 1300 000 171 and we\'ll help.'; });
    });
  }
  function initMap(fig) {
    if (fig.__t3p) return; fig.__t3p = 1;
    if (!('IntersectionObserver' in window)) { fig.classList.add('is-on'); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { fig.classList.add('is-on'); io.disconnect(); } });
    }, { threshold: 0.25 });
    io.observe(fig);
  }
  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-t3p-depot-finder]'), initFinder);
    Array.prototype.forEach.call(document.querySelectorAll('[data-t3p-depot-map]'), initMap);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
